import { appointment } from 'modules/schema';
import {
  ConfirmAppointmentBody,
  HTTPMethod,
  ConfirmAppointmentSuccessResponse,
  AppointmentsState,
  AppointmentTypesState,
  ChartsState,
} from 'types';
import { normalize } from 'normalizr';

export const confirmAppointmentQuery = (appointmentDetails: ConfirmAppointmentBody) => {
  const {
    appointment: { appointmentTypeId, scheduledDate },
    physicianId,
    practiceId,
  } = appointmentDetails;
  return {
    body: appointmentDetails,
    options: {
      method: HTTPMethod.post,
    },
    queryKey: `confirmAppointment:${appointmentTypeId}-${scheduledDate}-${physicianId}-${practiceId}`,
    transform: ({ data }: ConfirmAppointmentSuccessResponse) =>
      normalize(data, { appointment }).entities,
    update: {
      appointments: (
        prevAppointments: AppointmentsState,
        newAppointments: AppointmentsState,
      ): AppointmentsState => ({
        ...prevAppointments,
        ...newAppointments,
      }),
      appointmentTypes: (
        prevApptTypes: AppointmentTypesState,
        newApptTypes: AppointmentTypesState,
      ): AppointmentTypesState => ({
        ...prevApptTypes,
        ...newApptTypes,
      }),
      charts: (prevCharts: ChartsState, newCharts: ChartsState): ChartsState => ({
        ...prevCharts,
        ...newCharts,
      }),
    },
    url: 'book/api/appointments',
  };
};
